import $ from 'jquery';
import prestashop from 'prestashop';

prestashop.cart = prestashop.cart || {};

prestashop.cart.active_inputs = null;

let hasError = false;
let isUpdateOperation = false;
let errorMsg = '';

$(document).ready(() => {

  const promises = [];
  const $body = $('body');

  const abortPreviousRequests = () => {
    let promise;
    while (promises.length > 0) {
      promise = promises.pop();
      promise.abort();
    }
  };

  const handleupdateDeliveryCountryAction = (event) => {
    event.preventDefault();

    updateDeliveryCountry();
  };

  $body.on('change', prestashop.tsoSelectors.deliveryPayments.countryCarrierSelect, handleupdateDeliveryCountryAction);

  const handleUpdateCarrierAction = (event) => {
    event.preventDefault();

    updateCarrier();
  };

  $body.on('change', prestashop.tsoSelectors.deliveryPayments.deliveryInput, handleUpdateCarrierAction);

  const handleUpdatePaymentAction = (event) => {
    event.preventDefault();

    updatePayment();
  };

  $body.on('change', prestashop.tsoSelectors.deliveryPayments.paymentInput, handleUpdatePaymentAction);

  const loadPayments = () => {
    $(prestashop.tsoSelectors.deliveryPayments.paymentLoader).removeClass("off").addClass("on");
    $(prestashop.tsoSelectors.deliveryPayments.btnCartNavigation).attr('disabled', true);

    const requestData = {
      ajax: '1',
      method: 'loadPayments'
    };

    abortPreviousRequests();
    $.ajax({
      url: checkoutUrl,
      method: 'POST',
      data: requestData,
      dataType: 'json',
      beforeSend(jqXHR) {
        promises.push(jqXHR);
      },
    })
      .then((resp) => {
        if (resp.hasOwnProperty('hasError') && resp.hasError) {
          CheckUpdateDeliveryPaymentOperations.checkUpdateOpertation(resp);
          CheckUpdateDeliveryPaymentOperations.switchErrorStat();
        } else {
          $(prestashop.tsoSelectors.deliveryPayments.paymentsList).empty().append(resp.payments_content);
          $(prestashop.tsoSelectors.deliveryPayments.hookTopPayment).html(resp.HOOK_TOP_PAYMENT);

          $(prestashop.tsoSelectors.deliveryPayments.btnCartNavigation).attr('disabled', false);
          $(prestashop.tsoSelectors.deliveryPayments.paymentLoader).removeClass("on").addClass("off");
        }
      });
  };

  const setFirstDeliveryOption = () => {
    const selected_carrier = $(prestashop.tsoSelectors.deliveryPayments.deliveryInput + ':checked').length;

    if (!selected_carrier && !virtual_cart) {
      // set checked first carrier
      $(prestashop.tsoSelectors.deliveryPayments.deliveryInput).first().prop('checked', true);
    }

    // update carrier
    if (!virtual_cart) {
      updateCarrier(true);
    } else {
      loadPayments();
    }
  };

  const loadCarriers = () => {
    $(prestashop.tsoSelectors.deliveryPayments.deliveryLoader).removeClass("off").addClass("on");
    $(prestashop.tsoSelectors.deliveryPayments.btnCartNavigation).attr('disabled', true);

    const requestData = {
      ajax: '1',
      method: 'loadCarriers'
    };

    abortPreviousRequests();
    $.ajax({
      url: checkoutUrl,
      method: 'POST',
      data: requestData,
      dataType: 'json',
      beforeSend(jqXHR) {
        promises.push(jqXHR);
      },
    })
      .then((resp) => {
        if (resp.hasOwnProperty('hasError') && resp.hasError) {
          CheckUpdateDeliveryPaymentOperations.checkUpdateOpertation(resp);
          CheckUpdateDeliveryPaymentOperations.switchErrorStat();
        } else {
          $(prestashop.tsoSelectors.deliveryPayments.carriersList).empty().html(resp.carriers_content);

          $(prestashop.tsoSelectors.deliveryPayments.btnCartNavigation).attr('disabled', false);
          $(prestashop.tsoSelectors.deliveryPayments.deliveryLoader).removeClass("on").addClass("off");

          setFirstDeliveryOption();
        }
      });
  };

  const updateDeliveryCountry = () => {
    const id_country = parseInt($(prestashop.tsoSelectors.deliveryPayments.countryCarrierSelect).val());

    const requestData = {
      ajax: '1',
      method: 'updateCountry',
      type: 'delivery',
      id_country: id_country
    };

    if (!id_country) {
      return;
    }

    abortPreviousRequests();
    $.ajax({
      url: checkoutUrl,
      method: 'POST',
      data: requestData,
      dataType: 'json',
      beforeSend(jqXHR) {
        promises.push(jqXHR);
      },
    })
      .then((resp) => {
        CheckUpdateDeliveryPaymentOperations.checkUpdateOpertation(resp);
        CheckUpdateDeliveryPaymentOperations.switchErrorStat();

        // Refresh Cart Delivery
        loadCarriers();
      });
  };

  const updateCarrier = (force_update = false) => {
    $('#notifications .container').empty();

    const selected_carrier = $(prestashop.tsoSelectors.deliveryPayments.deliveryInput + ':checked');
    let old_selected_carrier;

    if (old_selected_carrier !== selected_carrier.val() || force_update === true) {
      $(prestashop.tsoSelectors.deliveryPayments.deliveryLoader).removeClass("off").addClass("on");
      $(prestashop.tsoSelectors.deliveryPayments.btnCartNavigation).attr('disabled', true);

      const id_address = selected_carrier.attr('data-id_address');
      const key = selected_carrier.attr('data-key');

      if (id_address === '' || key === '') {
        return;
      }

      const delivery_option_value = { [id_address]: key };

      const requestData = {
        ajax: '1',
        method: 'updateCarrier',
        delivery_option: delivery_option_value,
      };

      abortPreviousRequests();
      $.ajax({
        url: checkoutUrl,
        method: 'POST',
        data: requestData,
        dataType: 'json',
        beforeSend(jqXHR) {
          promises.push(jqXHR);
        },
      })
        .then((resp) => {
          if (resp.hasOwnProperty('hasError') && resp.hasError) {
            CheckUpdateDeliveryPaymentOperations.checkUpdateOpertation(resp);
            CheckUpdateDeliveryPaymentOperations.switchErrorStat();
          } else {
            $(prestashop.tsoSelectors.deliveryPayments.carriersList).empty().html(resp.carriers_content);

            $(prestashop.tsoSelectors.deliveryPayments.btnCartNavigation).attr('disabled', false);
            $(prestashop.tsoSelectors.deliveryPayments.deliveryLoader).removeClass("on").addClass("off");

            loadPayments();

            // Refresh cart preview
            prestashop.emit('updateCart', {
              reason: 'updateCarrier',
              resp,
            });
          }
        });
    }

    old_selected_carrier = selected_carrier.val();
  };

  const updatePayment = () => {
    const selected_payment = $(prestashop.tsoSelectors.deliveryPayments.paymentInput + ':checked');
    let old_selected_payment;

    if (old_selected_payment !== selected_payment.val()) {
      $(prestashop.tsoSelectors.deliveryPayments.paymentLoader).removeClass("off").addClass("on");

      const serialized_data_value = selected_payment.val();
      const checksum_value = selected_payment.attr('data-checksum');

      if (serialized_data_value === '' || checksum_value === '') {
        return;
      }

      const requestData = {
        ajax: '1',
        method: 'updatePayment',
        serialized_data: serialized_data_value,
        checksum: checksum_value,
      };

      abortPreviousRequests();
      $.ajax({
        url: checkoutUrl,
        method: 'POST',
        data: requestData,
        dataType: 'json',
        beforeSend(jqXHR) {
          promises.push(jqXHR);
        },
      })
        .then((resp) => {
          if (resp.hasOwnProperty('hasError') && resp.hasError) {
            CheckUpdateDeliveryPaymentOperations.checkUpdateOpertation(resp);
            CheckUpdateDeliveryPaymentOperations.switchErrorStat();
          } else {
            $(prestashop.tsoSelectors.deliveryPayments.paymentsList).empty().html(resp.payments_content);
            $(prestashop.tsoSelectors.deliveryPayments.hookTopPayment).empty().html(resp.HOOK_TOP_PAYMENT);

            $(prestashop.tsoSelectors.deliveryPayments.paymentLoader).removeClass("on").addClass("off");

            // Refresh cart preview
            prestashop.emit('updateCart', {
              reason: 'updatePayment',
              resp,
            });
          }
        });
    }

    old_selected_payment = selected_payment.val();
  };
});

const CheckUpdateDeliveryPaymentOperations = {
  switchErrorStat: () => {

    if (errorMsg !== '') {
      // eslint-disable-next-line
      const strError = ` <article class="alert alert-danger" role="alert" data-alert="danger"><ul><li>${errorMsg}</li></ul></article>`;
      $('#notifications .container').html(strError);
      errorMsg = '';
    } else {
      $('#notifications .container').empty();
    }
  },
  checkUpdateOpertation: (resp) => {

    hasError = resp.hasOwnProperty('hasError');
    const errors = resp.errors || '';

    // 1.7.2.x returns errors as string, 1.7.3.x returns array
    if (errors instanceof Array) {
      errorMsg = errors.join(' ');
    } else {
      errorMsg = errors;
    }

    isUpdateOperation = true;
  },
};